import {
    DetailsList,
    FontSizes,
    FontWeights,
    IconButton,
    PrimaryButton,
    ScrollablePane,
    SelectionMode,
    Stack,
} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {Link, useOutletContext, useParams} from "react-router-dom";
import AuthContext from "../../Services/AuthContext";
import AddVentureDocument from "../../Panel/VentureDocument/AddVentureDocument";
import AddAgreementProtocol from "../../Panel/AgreementProtocol/AddAgreementProtocol";
import EditAgreementProtocol from "../../Panel/AgreementProtocol/EditAgreementProtocol";
import {MoneyField} from "../../Utilities/MoneyField";
import AppContent from "../../Surfaces/AppContent";
import AddAgreementElement from "../../Panel/AgreementElement/AddAgreementElement";
import AgreementElementDataView from "./Agreement/AgreementElementDataView";
import AddPaymentRetention from "../../Panel/PaymentRetention/AddPaymentRetention";
import { netGrossField, useNetGross } from "../../Utilities/NetGrossField";
import * as PropTypes from "prop-types";
import AgreementFiles from "./Agreement/AgreementFiles";
import ChildrenAgreements from "./Agreement/ChildrenAgreements";
import PaymentRetentionDataView from "./Agreement/PaymentRetentionDataView";
import AgreementProtocolDataView from "./Agreement/AgreementProtocolDataView";
import ReturnBack from "../../Components/ReturnBack";
import InnerContent from "../../Surfaces/InnerContent";

function VentureAgreementDetails() {
    const [user] = useContext(AuthContext);
    const {actions} = useOutletContext();
    const [details, setDetails] = useState([]);
    const [files, setFiles] = useState([]);
    const [elements, setElements] = useState([]);
    const [protocols, setProtocols] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [subCosts, setSubCosts] = useState([])
    const [retentions, setRetentions] = useState([])
    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/venture/agreement/${params.aid}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setDetails(data.data);
                    setFiles(data.files);
                    setProtocols(data.protocols);
                    setElements(data.elements);
                    setSubCosts(data.agreements);
                    setRetentions(data.retentions);
                })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, refresh, user.token]);
    useEffect(() => {
        actions([
            {
                key: 'addDocument',
                text: 'Dodaj Plik',
                iconProps: { iconName: 'PageAdd' },
                onClick: () => setAddDocument({venture_id: params.id, venture_agreement_id: params.aid})
            },
            {
                key: 'addPaymentRetention',
                text: 'Dodaj Zatrzymanie',
                iconProps: { iconName: 'Lock' },
                onClick: () => setAddPaymentRetention(params.aid)
            },
            {
                key: 'addProtocol',
                text: 'Dodaj Protokół',
                iconProps: { iconName: 'DependencyAdd' },
                onClick: () => setAddProtocol({contractor_id: details.contractor_id, venture_agreement_id: params.aid})
            },
            {
                key: 'addElement',
                text: 'Dodaj Element',
                iconProps: { iconName: 'AppIconDefaultAdd' },
                onClick: () => setAddElement({venture_agreement_id: params.aid})
            },
        ]);
        return actions;
    }, [details]);

    const [addDocument, setAddDocument] = useState(false);

    const [addProtocol, setAddProtocol] = useState(false);
    const [addElement, setAddElement] = useState(false);
    const [addPaymentRetention, setAddPaymentRetention] = useState(false);


    const _refresh = () => setRefresh((prev) => prev + 1);
    const netGross = useNetGross();



    return (<InnerContent title={`Umowa ${details?.name}`} backTo={`/venture/${params.id}/cost`}>
            <AgreementElementDataView items={elements} refresh={_refresh} netGross={netGross}
                                      total={details[netGrossField()]} />
            <Stack horizontal tokens={{ childrenGap: 'l2' }} horizontalAlign="space-between" wrap>
                <AgreementProtocolDataView agreement={details} items={protocols} netGross={netGross} refresh={_refresh}/>
                <ChildrenAgreements agreement={details} items={subCosts} netGross={netGross} />
                <PaymentRetentionDataView items={retentions} refresh={_refresh}/>
                <AgreementFiles items={files}  />
            </Stack>
            <AddVentureDocument add={addDocument} dismissPanel={() => setAddDocument(false)}
                                onSuccess={_refresh} />
            <AddAgreementElement add={addElement} onSuccess={_refresh}
                                 dismissPanel={() => setAddElement(false)} />
            <AddAgreementProtocol add={addProtocol} onSuccess={_refresh}
                                  dismissPanel={() => setAddProtocol(false)}
                                  total={{ net: details.net_value, vat: details.vat, gross: details.gross_value }} />
            <AddPaymentRetention add={addPaymentRetention} onSuccess={_refresh}
                                 dismissPanel={() => setAddPaymentRetention(false)} />
        </InnerContent>
    );
}

export default VentureAgreementDetails;